module.exports = __webpack_public_path__ + "static/img/icp.557ec47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icp.png
// module id = bSj4
// module chunks = 1